/**
 * Show a flash message alert using Bootstrap alert component
 * @param {string} message - The message to display
 * @param {string} type - Bootstrap alert type: 'success', 'danger', 'warning', 'info'
 * @param {number} duration - Auto-dismiss duration in milliseconds (default: 5000)
 */
export function showFlashMessage(message, type = 'info', duration = 5000) {
  const alertHtml = `
    <div class="alert alert-${type} alert-dismissible fade in" role="alert">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      ${message}
    </div>
  `

  const flashContainer = document.querySelector('#flash-messages, .container:first-of-type, main, body > div:first-child')
  if (flashContainer) {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = alertHtml
    const alertElement = tempDiv.firstElementChild
    flashContainer.insertBefore(alertElement, flashContainer.firstChild)

    // Initialize Bootstrap alert
    $(alertElement).alert()

    // Auto-dismiss after specified duration
    if (duration > 0) {
      setTimeout(() => {
        $(alertElement).alert('close')
      }, duration)
    }
  }
}
